module.exports = __webpack_public_path__ + "img/bottomLogo.a7551f7b.png";